import styled from 'styled-components';
import toRem from 'utils/toRem';
import { grey10 } from '../../constants/variables';
import ProductBadge from 'components/product_show/product_badge';
import ProductPrice from 'components/products/product_price';
import getBadgeVariant from 'utils/getBadgeVariant';

const Product = styled.a`
  padding: ${toRem(16)} ${toRem(12)};
  border: 1px solid ${grey10};
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .product-badge {
    top: ${toRem(16)};
  }
`;

const BrandImage = styled.img`
  max-height: 100%;
  width: auto;
`;

const ProductName = styled.h3`
  margin-bottom: auto;
`;

const ProductItem = ({
  brand_image: brandImage,
  image,
  name,
  stock_code: stockCode,
  part_code: partCode,
  price,
  price_incl_vat: priceInclVat,
  quantity_per_price: quantityPerPrice,
  price_unit: unit,
  url,
  is_on_sale: isOnSale,
  was_price: wasPrice,
  was_price_incl_vat: wasPriceIncVat,
}) => {
  const badgeVariant = getBadgeVariant({
    priceBeforeCurrentSale: wasPrice,
    priceBeforeCurrentSaleIncVAT: wasPriceIncVat,
  });

  return (
    <Product
      href={url}
      className="product--listings_product d-block bg-white tc-main">
      <div className="product-item__brand-icon mb-10">
        <BrandImage src={brandImage} alt="" width="90" />
      </div>
      {badgeVariant && <ProductBadge variant={badgeVariant} />}
      <img
        className="product-item__img d-block mb-10 margin-center"
        src={image}
        alt={name}
        width="140"
        height="140"
      />
      <ProductName className="fs-16 ff-body lh-1-2 tc-main fw-700">
        {name}
      </ProductName>
      <div className="mb-20 mt-10">
        <ul className="no-bullet">
          <li>
            <span className="fs-14 tc-grey-60">Part Code: </span>
            <span className="tc-secondary">{partCode}</span>
          </li>
          <li>
            <span className="fs-14 tc-grey-60">Stock Code: </span>
            <span className="tc-secondary">{stockCode}</span>
          </li>
        </ul>
      </div>
      <ProductPrice
        isOnSale={isOnSale}
        price={{
          price,
          price_inclusive: priceInclVat,
          quantity: parseInt(quantityPerPrice),
          unit,
        }}
        priceBeforeCurrentSale={wasPrice}
        priceBeforeCurrentSaleIncVAT={wasPriceIncVat}
        vatExclusive={true}
      />
    </Product>
  );
};

export default ProductItem;
